var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerPinBlueUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5999 7.00002C13.5999 3.34002 10.6599 0.400024 6.9999 0.400024C3.3399 0.400024 0.399902 3.34002 0.399902 7.00002C0.399902 8.44002 0.939902 9.64002 1.3599 10.3C1.5999 10.66 6.3999 18.4 6.3999 18.4H5.7999C5.1399 18.4 4.5999 18.94 4.5999 19.6H9.3999C9.3999 18.94 8.8599 18.4 8.1999 18.4H7.5999C7.5999 18.4 12.3999 10.66 12.6399 10.3C13.0599 9.64002 13.5999 8.44002 13.5999 7.00002ZM11.6199 9.64002C11.4399 10 8.1999 15.22 6.9999 17.08C5.7999 15.22 2.5599 9.94002 2.3799 9.64002C2.0199 9.10002 1.5999 8.08002 1.5999 7.00002C1.5999 4.00002 3.9999 1.60002 6.9999 1.60002C9.9999 1.60002 12.3999 4.00002 12.3999 7.00002C12.3999 8.08002 11.9799 9.10002 11.6199 9.64002ZM9.9999 7.00002C9.9999 8.68002 8.6799 10 6.9999 10C5.3199 10 3.9999 8.68002 3.9999 7.00002C3.9999 5.32002 5.3199 4.00002 6.9999 4.00002C8.6799 4.00002 9.9999 5.32002 9.9999 7.00002ZM6.9999 5.20002C5.9799 5.20002 5.1999 5.98002 5.1999 7.00002C5.1999 8.02002 5.9799 8.80002 6.9999 8.80002C8.0199 8.80002 8.7999 8.02002 8.7999 7.00002C8.7999 5.98002 8.0199 5.20002 6.9999 5.20002Z",
    fill: "#0562D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerPinBlueUpdated);
export default __webpack_public_path__ + "static/media/dealer-pin-blue-updated.cece82645e3ba25925cb39831697a72e.svg";
export { ForwardRef as ReactComponent };